const SELECT_SELECTORS = '.select-services, .select-faq';

class SelectComponent {
    constructor(el) {
        this.el = el;
        this.button = el.querySelector('.select-services__button, .select-faq__button');
        this.list = el.querySelector('.select-services__list, .select-faq__list');
        this.label = el.querySelector('.select-services__label, .select-faq__label');
        this.native = el.querySelector('.select-services__native, .select-faq__native');

        if (!this.button || !this.list) return;

        this.bindEvents();
        if (this.native) this.syncFromNative();
    }

    bindEvents() {
        this.button.addEventListener('click', e => {
            e.stopPropagation();
            this.toggleList();
        });

        this.list.addEventListener('click', e => {
            const li = e.target.closest('li');
            if (!li || !this.list.contains(li)) return;

            if (!this.native) {
                return;
            }

            e.preventDefault();

            const value = li.getAttribute('data-value') !== null ? li.getAttribute('data-value') : '';
            const anchor = li.querySelector('a');
            const text = anchor ? anchor.textContent.trim() : li.textContent.trim();

            this.native.value = value;
            if (this.label) this.label.textContent = text;

            this.list.querySelectorAll('li').forEach(item => item.classList.remove('is-selected'));
            li.classList.add('is-selected');

            this.list.classList.add('hide');
            this.button.setAttribute('aria-expanded', 'false');

            this.native.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (this.native) {
            this.native.addEventListener('change', () => this.syncFromNative());
        }
    }

    toggleList() {
        const willOpen = this.list.classList.contains('hide');

        document.querySelectorAll(SELECT_SELECTORS).forEach(other => {
            const otherList = other.querySelector('.select-services__list, .select-faq__list');
            const otherButton = other.querySelector('.select-services__button, .select-faq__button');
            if (otherList) otherList.classList.add('hide');
            if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
        });

        if (willOpen) {
            this.list.classList.remove('hide');
            this.button.setAttribute('aria-expanded', 'true');
        }
    }

    syncFromNative() {
        if (!this.native || !this.list) return;

        const value = String(this.native.value);
        const items = this.list.querySelectorAll('li');
        let matched = null;

        items.forEach(li => {
            const v = String(li.getAttribute('data-value') !== null ? li.getAttribute('data-value') : '');
            const isSelected = v === value;
            li.classList.toggle('is-selected', isSelected);
            if (isSelected) matched = li;
        });

        if (this.label) {
            if (matched) {
                const anchor = matched.querySelector('a');
                this.label.textContent = anchor ? anchor.textContent.trim() : matched.textContent.trim();
            }
        }
    }
}

function bindGlobalCloseHandler() {
    if (window.__selectServicesGlobalBound) return;
    window.__selectServicesGlobalBound = true;

    document.addEventListener('click', e => {
        document.querySelectorAll(SELECT_SELECTORS).forEach(el => {
            if (el.contains(e.target)) return;
            const list = el.querySelector('.select-services__list, .select-faq__list');
            const button = el.querySelector('.select-services__button, .select-faq__button');
            if (list) list.classList.add('hide');
            if (button) button.setAttribute('aria-expanded', 'false');
        });
    });
}

export function initSelectServices() {
    document.querySelectorAll(SELECT_SELECTORS).forEach(el => new SelectComponent(el));
    bindGlobalCloseHandler();
}
